import React from 'react';
import { Typography, Button, IconButton, Tooltip } from '@mui/material';
import { BulkActionsToolbarProps } from '../../types';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  StyledToolbar,
  ActionsContainer,
} from '../styled/bulk-actions-toolbar-styles';

export function BulkActionsToolbar<T>({
  selectedRows,
  selectedIds,
  bulkActions,
  onClearSelection,
}: BulkActionsToolbarProps<T>) {
  if (selectedIds.length === 0) {
    return null;
  }

  return (
    <StyledToolbar>
      <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
        {selectedIds.length} {selectedIds.length === 1 ? 'item' : 'items'}{' '}
        selected
      </Typography>

      <ActionsContainer>
        {bulkActions.map((action) => {
          const isDisabled =
            action.disabled === true ||
            (typeof action.disabled === 'function' &&
              action.disabled(selectedRows));

          const handleClick = async () => {
            if (!isDisabled) {
              await action.action(selectedIds, selectedRows);
            }
          };

          // Use custom MUI Button variants from global-mui-button.d.ts
          const variant = [
            'primary',
            'outlined',
            'naked',
            'link',
            'accent',
            'action',
          ].includes(action.variant || '')
            ? (action.variant as
                | 'primary'
                | 'outlined'
                | 'naked'
                | 'link'
                | 'accent'
                | 'action')
            : 'primary';
          const color = [
            'primary',
            'secondary',
            'error',
            'warning',
            'info',
            'success',
          ].includes(action.color || '')
            ? (action.color as
                | 'primary'
                | 'secondary'
                | 'error'
                | 'warning'
                | 'info'
                | 'success')
            : 'primary';

          return (
            <Button
              key={action.id}
              variant={variant}
              color={color}
              disabled={isDisabled}
              onClick={handleClick}
              startIcon={action.icon}
            >
              {action.label}
            </Button>
          );
        })}

        <Tooltip title="Clear selection">
          <IconButton color="inherit" onClick={onClearSelection} size="small">
            <SystemIcon iconName="X" />
          </IconButton>
        </Tooltip>
      </ActionsContainer>
    </StyledToolbar>
  );
}
